import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { useLocation } from "react-router-dom";
function WhatsAppButton() {
const location = useLocation();

if (location.pathname === "/") {
  return null;
}

  const phoneNumber = "916370819340";
  const message = "Hello isabistudio! I need help.";

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (

    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 bg-[#25D366] text-white p-4 rounded-full shadow-lg hover:scale-110 transition z-50"
    >

      <FaWhatsapp size={28} />

    </a>

  );

}

export default WhatsAppButton;